import styled from 'styled-components';

export const MobileHistoryTransactionClockIconContainerStyled = styled.div`
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    svg {
        height: 16px;
        width: 16px;
    }
`;
